<template>
  <div id="boardChart">
    <div class="tools">
      <p @click="close()">x</p>
    </div>
    <div class="chart-content">
      <div class="chart">
        <StockChart
          ref="Chart"
          :isDragUnableOnPoints="false"
          :seriesDetails="series"
          :enable-tooltip="true"
          :enable-x-axies-labels="true"
          :enable-y-axies-labels="true"
          :enable-legend="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StockChart from '../charts/StockChart.vue';

export default {
  name: 'seriesComparator',
  data() {
    return {};
  },
  props: {
    ts: Array,
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
  },
  computed: {
    series() {
      let x = [];
      this.ts.forEach((e) =>
        x.push({
          data: e.data,
          name: e.name,
        })
      );
      return x;
    },
  },
  components: {
    StockChart,
  },
};
</script>

<style scoped>
.chart {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  background: #fff;
  -webkit-box-shadow: 0 0 20px rgba(31, 37, 50, 0.2);
  box-shadow: 0 0 20px rgba(31, 37, 50, 0.2);
  border: 1px solid #d6d6dd;
  image-rendering: optimizeQuality;
  padding: 35px 35px 35px 15px;
}

#boardChart {
  -webkit-font-smoothing: antialiased;
  position: fixed;
  width: 100%;
  height: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1003;
  text-align: left;
  background: #fff;
  color: #41495a;
}

.label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 31px;
  font-size: 14px;
}

.value {
  margin-bottom: 8px;
}

.big-font {
  font-size: 28px;
}

.small {
  color: #8c96a9;
  font-weight: 200;
}

.clickable {
  cursor: pointer;
  color: #8c96a9;
  font-weight: 200;
  font-size: 14px;
}

.half {
  display: inline-block;
  width: 40%;
}

.value.small {
  color: #687082;
  font-size: 13px;
  font-weight: 200;
}

.value.small input {
  padding: 0;
}
.value.small select {
  border: none;
  outline: none;
  background: white;
}

.info-item {
  margin: 0;
}

.chart-content {
  box-sizing: border-box;
  text-align: center;
  margin-top: 0;
  -webkit-transition: padding 0.3s;
  -o-transition: padding 0.3s;
  transition: padding 0.3s;
  position: absolute;
  padding-left: 75px;
  -webkit-box-sizing: border-box;
  width: 95%;
  height: 100%;
}

.chart-switch {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 19;
  padding-right: 497px;
}

.chart-switch i {
  font-size: 50px;
  padding: 0 25px 0 25px;
  cursor: pointer;
}

.chart-wrap {
  top: 0;
  left: 0;
  -webkit-transition: padding 0.3s;
  -o-transition: padding 0.3s;
  transition: padding 0.3s;
  box-sizing: border-box;
  position: absolute;
  padding: 100px 497px 100px 38px;
  -webkit-box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: block;
}
.side-panel {
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  width: 439px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgba(20, 26, 40, 0.08);
  overflow-y: scroll;
}
.side-panel-inner {
  text-align: left;
  margin-top: 100px;
}
.side-bar-options.wrapper {
  position: fixed;
  top: 0;
  padding-top: 25px;
  width: inherit;
  background: white;
  text-align: right;
}

.side-bar-options {
  padding-right: 25px;
}

.side-bar-options ul {
  display: block;
  list-style-type: none;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.side-bar-options li {
  display: inline-block;
  margin-left: 10px;
}

.side-bar-options {
  z-index: 20;
}

.side-bar-options > li.download .download-excel:hover {
  background: rgba(0, 0, 0, 0.03);
  background-image: url('../../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  background-position: -1212px -425px;
  transition: color 0.15s;
  cursor: pointer;
}

.side-bar-options > li.download .download-excel {
  box-sizing: border-box;
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  top: 11px;
  left: 11px;
  background: #fff;
  background-image: url('../../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  background-position: -1212px -425px;
  transition: color 0.15s;
}

.side-bar-options > li > a:hover {
  background: rgba(0, 0, 0, 0.03);
  background-image: url('../../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  transition: color 0.15s;
  cursor: pointer;
}

.side-bar-options > li > a {
  box-sizing: border-box;
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  top: 11px;
  left: 11px;
  background: #fff;
  background-image: url('../../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  transition: color 0.15s;
}

.side-bar-options > li.share > a {
  background-position: -1212px -178px;
}

.side-bar-options > li.sidebar-toggle > a {
  background-position: -219px -1197px;
}

.side-bar-options > li.close-modal > a {
  background-position: -442px -1131px;
}

.accessibility {
  z-index: 30;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 0px !important;
}

.load-details {
  margin: 10%;
  max-width: 80%;
  display: block;
  text-align: left;
  padding: 0px;
}

.load-details .rename.title {
  width: 100%;
  color: #1f2532;
  width: 100%;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
  margin-bottom: 15px;
  padding: 0;
}

.load-details .rename.subtitle {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  color: #1f2532;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.125px;
  padding: 0 0 3px;
  margin-top: 7px;
  margin-bottom: 7px;
  top: 0;
  left: 0;
  height: 20px;
  width: 100%;
}

.load-details > input.rename::placeholder {
  content: attr(data-placeholder);
  color: #a0a4ad;
  font-style: inherit;
  display: block;
}

.load-details > input.rename:focus {
  outline: medium none;
  border: 1px solid #e6e7ea;
}

.load-details .analysis-title {
  font-size: 11px;
  color: rgb(53 71 87);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  max-width: 220px;
  overflow: hidden;
  font-family: 'Open Sans', open-sans, sans-serif;
  line-height: 23px;
}

.load-details .load-statistics {
  font-family: 'Open Sans', open-sans, sans-serif;
  color: #22303c;
  font-size: 14px;
  margin-top: 40px;
}

.vertical-btns {
  margin-left: 15px;
  width: 100px;
  display: inline-block;
}

.vertical-btns > button {
  font-size: 27px;
  background: none;
  border-style: none;
  margin-left: 5px;
}

.row {
  margin: 0px;
}

.operations label {
  margin-top: 10px;
  margin-bottom: 0;
  color: #a4a4a4;
}
.operation-methods .row {
  margin-bottom: 15px;
}
.operations a {
  text-decoration: underline;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
}
.operation-method.btn {
  width: 33px;
  height: 32px;
  border-radius: 10px;
  margin: 4px;
  padding: 0;
  border: solid 1px #9da0a8;
  background: #22303c;
  color: white;
  padding: 0;
  line-height: 32px;
}

.operation-method.btn:hover {
  border: solid 1px #ffff;
}
.operation-method.grey-out.btn:hover {
  border: solid 1px #9da0a8;
}
.operation-method.grey-out.btn {
  color: #727274;
}

input[type='datetime-local']::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 10%;
  padding-left: 80%;
  cursor: pointer;
}

.operations {
  background: #22303c;
  color: white;
  border-radius: 5px;
  padding: 15px 0px;
  display: block;
  transition: transform 0.2s ease-in, opacity 0.2s ease,
    -webkit-transform 0.2s ease-in;
  transition: transform 0.2s ease-in, height 0.2s ease,
    -webkit-transform 0.2s ease-in;
  animation: fadeIn 1s;
  overflow: hidden;
}

.operations input {
  border: solid 1px #9da0a8;
  border-radius: 3px;
  background: #22303c;
  color: white;
  width: 100%;
  box-sizing: border-box;
  padding-left: 12px;
}

.operations input[type='checkbox'] {
  width: 12px;
  margin: 0;
  margin-right: 10px;
}

@keyframes fadeIn {
  0% {
    margin-top: 50px;
    opacity: 0;
  }
  50% {
    margin-top: 0px;
    opacity: 1;
  }
  100% {
    margin-top: 0px;
    opacity: 1;
  }
}

input[type='datetime-local']::-webkit-calendar-picker-indicator {
  opacity: 0.8;
  filter: invert(1);
}

.button {
  border-radius: 22px;
  padding: 8px 21px 8px 21px;
  float: left;
  margin: 0px 1px 0 19px;
  outline: 0;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.13px;
  color: #fff;
  border: solid 1px #9da0a8;
}

.button.save {
  width: 65px;
  height: 25px;
}

.button.save.saving {
  color: #9cf435;
  border: solid 1px #71b225;
}

.button.save.saving:hover i {
  border: none;
}

.button.save.disabled {
  opacity: 0.5;
}

.button:hover :not(.disabled) {
  border: solid 1px #ffff;
  transition: 200ms;
}

.button.save span {
  border-style: none;
}

.malo-id {
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 19px;
  line-height: 36px;
  font-weight: 600;
  color: #1f2532;
}

.operation-method.day.btn {
  font-size: 12px;
  line-height: 34px;
}

.operation-method.day.btn.clicked {
  background-color: #ffff;
  border-color: #ffff;
  color: #22303c;
}

.btn.remove-value {
  margin-left: -2px;
  background-image: url('../../assets/img/series_negative_val.svg');
  background-size: 25px 25px;
  background-position: 50%;
  background-repeat: no-repeat;
}

.custom-picker {
  margin-top: 15px;
}

.tools {
  float: right;
  margin-top: 10px;
  font-size: 20px;
  z-index: 1500;
  cursor: pointer;
}
</style>
